import { render, staticRenderFns } from "./AspectTableSorting.vue?vue&type=template&id=3d18b3f4&scoped=true&"
import script from "./AspectTableSorting.vue?vue&type=script&lang=js&"
export * from "./AspectTableSorting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d18b3f4",
  null
  
)

export default component.exports